/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { CaseStudyCard } from 'landing-pages/shared/CaseStudyCard/CaseStudyCard';

export const FddTestimonial = () => {
  const { t } = useInt();

  return (
    <CaseStudyCard
      theme="light"
      company="PwC"
      title={t('PwC: Enhancing Business Development')}
      summary={t(
        'PwC Colombia filters and enriches its CRM with accurate, up-to-date firmographic and financial data — the same due-diligence-grade information its audit and consulting teams rely on.',
      )}
      href="/pwc-enhancing-business-development-with-accurate-and-up-to-date-information"
    />
  );
};
